import {
    DEALERADDUPDATEDISTRICTLIST_SUCCESS,
    DEALERADDUPDATEDISTRICTLIST_FAILED,
    RESET_DEALERADDUPDATEDISTRICTLIST,
    LOADING_DEALERADDUPDATEDISTRICTLIST,
    NETWORK_ERROR_DEALERADDUPDATEDISTRICTLIST
} from "../types/index";

import { dealerServices } from "../../config/axios";

const resetDealerAddUpdateDistrictList = () => {
    return { type: RESET_DEALERADDUPDATEDISTRICTLIST };
};


const dealerAddUpdateDistrictList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDUPDATEDISTRICTLIST });
    await dealerServices
        .post("districtList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddUpdateDistrictListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddUpdateDistrictListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDUPDATEDISTRICTLIST,
                payload: err
            });
        });
}


function dealerAddUpdateDistrictListsuccess(data) {
    return {
        type: DEALERADDUPDATEDISTRICTLIST_SUCCESS,
        payload: data
    }
}

function dealerAddUpdateDistrictListFailed(data) {
    return {
        type: DEALERADDUPDATEDISTRICTLIST_FAILED,
        payload: data
    }
}

export { resetDealerAddUpdateDistrictList, dealerAddUpdateDistrictList }